(function($) {
  class WillPaginate {

    constructor(element, options){

      this.DEFAULT = {
        activeClass: '.active',
        prevClass: '.prev',
        nextClass: '.next'
      }

      this.options = $.extend({}, this.DEFAULT, options);

      this.$el = $(element)
      this.$container = this.$el.find('ul')

      this.$active = this.$el.find(this.options.activeClass)
      this.$prev = this.$el.find(this.options.prevClass)
      this.$next = this.$el.find(this.options.nextClass)
      this.$first = this.$prev.next()
      this.$last = this.$next.prev()

      this.shownPages = []
      for (let aux = this.$active.prev(), i = 0 ; aux.not('.prev')[0] && i < 4 ; i++, aux = aux.prev()){
        this.shownPages.push(aux[0])
      }
      for (let aux = this.$active.next(), i = 0 ; aux.not('.next')[0] && ( i < 2 || this.shownPages.length < 4); i++, aux = aux.next()){
        if (this.shownPages.length == 4) this.shownPages.pop()
        this.shownPages.unshift(aux[0])
      }
      this.shownPages.push(this.$active[0])

      this.$active.addClass('disabled')
      this.$prev.find('a').text('<')
      this.$next.find('a').text('>')

      if (!this.shownPages.includes(this.$first[0])){
        $('<li class="disabled willPaginate-shown"><a href="#">...</a></li>').insertAfter(this.$prev)
        this.$first.prependTo(this.$container).find('a').text('<<')
      } else {
        $('<li class="disabled willPaginate-shown"><a href="#">&lt;&lt;</a></li>').prependTo(this.$container)
      }

      if (!this.shownPages.includes(this.$last[0])) {
        $('<li class="disabled willPaginate-shown" title="'+this.$last.text()+'"><a href="#">...</a></li>').insertBefore(this.$next)
        this.$last.attr('title',this.$last.text()).find('a').text('>>')
        this.$last.appendTo(this.$container)
      } else {
        $('<li class="disabled willPaginate-shown"><a href="#">&gt;&gt;</a></li>').appendTo(this.$container)
      }


      this.$el.find([
        this.$prev[0],
        this.$next[0],
        this.$first[0],
        this.$last[0],
        ...this.shownPages,
      ]).addClass('willPaginate-shown')
    }

  }

  $.fn.willPaginate = function (options) {
    return this.each(function () {
      if (!$(this).data('willPaginate')) {
        $(this).data('willPaginate', new WillPaginate(this, Object.assign({},options)));
      }
    });
  };

  $('.willPaginate').willPaginate();
})($);